import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@mzic/mzic-environments';
import { ImageCDNSizes } from '../../enums';

@Pipe({
  name: 'mzicImage',
  standalone: true,
})
export class MzicImagePipe implements PipeTransform {
  transform(
    imageToken: string,
    width: ImageCDNSizes = ImageCDNSizes.DEFAULT,
  ): string {
    // Se o token for uma imagem regular, retorna o mesmo
    if (this.regularImage(imageToken)) {
      return imageToken;
    }

    return `${environment.cdnUrl}/${imageToken}/${width}/image`;
  }

  regularImage(image: string) {
    return image?.includes('https://') || image?.includes('http://');
  }
}
